module.exports = __webpack_public_path__ + "img/888.c5464ac2.png";